import styled from "styled-components";

import { Box, FlexContainer, FlexDiv } from "@/components/Atoms";
import { Typography } from "@/foundation/Typography/V1";

export const RedDiv = styled(FlexDiv)`
  background: ${({ theme }) => theme.colors.linearGradRed};
  padding: 35px 0;
`;

export const LHSDiv = styled(FlexDiv)`
  max-width: 285px;
  margin-right: 15px;
  @media only screen and (max-width: 992px) {
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 25px;
    align-items: center;
    text-align: center;
  }
`;

export const WhyShyft = styled(FlexContainer)`
  text-align: center;
  align-items: center;
  @media only screen and (max-width: 1169px) {
    text-align: left;
    align-items: flex-start;
  }
`;

export const RHSDiv = styled(FlexDiv)`
  flex: 1;
  max-width: 100%;
  min-width: 1px;
  .slick-slider {
    width: 100%;
    .slick-dots {
      li {
        &.slick-active {
          button {
            &::before {
              background-color: ${({ theme }) => theme.colors.dotsColor};
            }
          }
        }
        button {
          position: relative;
          &::before {
            background-color: rgba(92, 92, 110, 0.2);
            border-radius: 50%;
            height: 8px;
            width: 8px;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }
  }
`;

export const IconRing = styled(Box)`
  height: 78px;
  width: 78px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.shadeRed};
  overflow: hidden;
`;

export const FlexDom = styled(FlexContainer)`
  @media only screen and (max-width: 992px) {
    flex-direction: column;
  }
`;

export const WhyShyftText = styled(Typography)`
  @media only screen and (max-width: 639px) {
    line-height: 24px;
  }
`;
